import { render, staticRenderFns } from "./BookingLogs.vue?vue&type=template&id=3b611a06&"
import script from "./BookingLogs.vue?vue&type=script&lang=js&"
export * from "./BookingLogs.vue?vue&type=script&lang=js&"
import style0 from "./BookingLogs.vue?vue&type=style&index=0&id=3b611a06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports